import services from 'services/services';
import * as types from '../types';
import { setRequestUrl } from 'store/actions';

// Import helpers
import {
	checkFetchErrors,
	queryParams
} from '../helpers_actions/convert_helpers';

// Import variables
import { TABLE_LENGTH } from 'components/helpers/table';

// ******************** FETCH DEVICES ********************
export const fetchSubscriberDevicesSn = (options, itemId) => async (
	dispatch,
	getState
) => {
	try {
		dispatch({
			type: types.FETCH_SUBSCRIBER_DEVICES_SN_LOADING
		});

		const {
			subscribers: {
				devicesSn: {
					columns,
					options: { startIndex: startTableIndex, page }
				}
			}
		} = getState();

		// options may be unavailable when refetching after assigining device to subscriber
		const startIndex = options
			? options.page === page
				? startTableIndex
				: options.startIndex
			: 0;

		const url = `/subscriber/serialnumbers/${itemId}/list?${options &&
			queryParams(options, TABLE_LENGTH, columns, startIndex, true)}`;

		const { data } = await services.get(url);

		// Calculate pages
		const pages = Math.ceil(data.recordsFiltered / TABLE_LENGTH);

		dispatch({
			type: types.FETCH_SUBSCRIBER_DEVICES_SN_SUCCESS,
			payload: { ...data, pages, page: options?.page ?? 0, startIndex }
		});

		// save request url in redux
		setRequestUrl(url)(dispatch);
	} catch (error) {
		dispatch({
			type: types.FETCH_SUBSCRIBER_DEVICES_SN_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};

// ******************** DETACH DEVICE ********************
export const detachDeviceSn = (subscriberId, deviceId) => async (dispatch) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.DETACH_DEVICE_SN_LOADING,
			payload: true
		});

		const url = `/subscriber/serialnumbers/${deviceId}/detach`;

		await services.patch(url, { subscriber_id: subscriberId });

		// Dispatch an action with data
		dispatch({
			type: types.DETACH_DEVICE_SN_SUCCESS,
			payload: true
		});
	} catch (error) {
		// Dispatch an action with error set to true
		dispatch({
			type: types.DETACH_DEVICE_SN_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};
